import React, { Component, MouseEvent } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { WorkOrderData } from '../../apis/workOrder.api'
import routes from '../../routes/routes'

interface Props extends RouteComponentProps {
    workOrder: WorkOrderData
}

class WorkOrder extends Component<Props> {
  constructor (props: Props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  get className () {
    const { workOrder } = this.props
    const base = 'text-[0.675rem] text-white truncate inline-block px-1'
    const background = workOrder.materialStockout ? 'bg-red-500 hover:bg-red-400' : 'bg-green-500 hover:bg-green-400'
    return `${base} ${background}`
  }

  handleClick (event: MouseEvent) {
    event.stopPropagation()
    const pathname = routes.workOrder
    const state = { id: this.props.workOrder.id }
    this.props.history.push({ pathname, state })
  }

  render () {
    return (
            <div
                className={this.className}
                onClick={this.handleClick}>
                {this.props.workOrder.code}
            </div>
    )
  }
}

export default withRouter(WorkOrder)
